// @flow

import {Dom, Loc} from 'main.core';
import {Form} from './form';

export class FormLizingMainPage
{
	#app;
	constructor(rootNode): void
	{
		this.rootNode = document.querySelector(rootNode);
	}

	start(): void
	{
		this.attachTemplate();
	}
	attachTemplate(): void
	{
		this.#app = BX.Vue3.BitrixVue.createApp({
			components: {
				Form
			},
			template: `
				<div>
					<Form/>
				</div>
				`
		});
		this.#app.mount(this.rootNode);
	}
}
